import { FeatureFlag } from '../FeatureFlag';

export const useNextGenProxy = new FeatureFlag({
    key: 'use-nextgen-proxy',
    createdOn: '2026-07-22',
    defaultValue: false,
});
